import { useState, useContext } from 'react';
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, InputBase, IconButton, Grid } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { HomeContext } from '../utils/contexts/homeContext';
import { FormMode } from '../utils/extensions/constantEx'

const EmployeeHeader = (props) => {
    const { handleEmpSearchClick } = props;
    const { homeState } = useContext(HomeContext);

    const navigate = useNavigate();

    const [searchText, setSearchText] = useState(homeState.employeeSearchText.length > 0 ? homeState.employeeSearchText : '');

    const handleNewEmployeeClick = () => {
        navigate("/employee-form", {
            replace: false,
            state: {
                formMode: FormMode.NewMode,
                from: 'search-employees',
                selectedId: 0
            }
        });
    }

    const handleSearchClick = async () => {
        const tempSearchText = searchText.trim();
        setSearchText(tempSearchText);
        await handleEmpSearchClick(tempSearchText);
    }

    return (
        <Paper>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={2}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        Employees
                    </Typography>
                </Grid>
                <Grid size={8}>
                    <Paper variant="outlined"
                        sx={{ display: 'flex', alignItems: 'center', mt: 1 }}
                    >
                        <InputBase value={searchText}
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search by employee code / name"
                            onChange={(event) => {
                                setSearchText(event.target.value);
                            }}
                        />
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search employee" onClick={handleSearchClick}>
                            <SearchIcon />
                        </IconButton>
                    </Paper>
                </Grid>
                <Grid size={2}>
                    <Box sx={{ pr: 1, textAlign: 'right', paddingTop: '14px' }}>
                        <Button variant="outlined" onClick={handleNewEmployeeClick}>Add Employee</Button>
                    </Box>
                </Grid>
            </Grid>
        </Paper>

    );
}
export default EmployeeHeader;